import styled from 'styled-components';
import { FlexColumn } from '@elementary/common-ui/components';
import { Typography } from '@mui/material';

const Wrapper = styled(FlexColumn)`
  justify-content: center;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.palette.common.gray13};
  box-shadow: 0px 16px 250px 0px
    ${({ theme }) => theme.palette.common.blackOpacity5};
  backdrop-filter: blur(8px);
  border-radius: 16px;
  padding: 80px;
  gap: 16px;
`;

type Props = {
  title: string;
  description: string;
};

const RuleEmptyState = ({ title, description }: Props) => (
  <Wrapper>
    <Typography sx={{ fontWeight: 'bold', lineHeight: 'normal' }}>
      {title}
    </Typography>
    <Typography sx={{ fontSize: '14px', lineHeight: 'normal' }}>
      {description}
    </Typography>
  </Wrapper>
);

export default RuleEmptyState;
